export default "__VITE_ASSET__iNwWarMu__ 480w, __VITE_ASSET__CikANO$k__ 720w, __VITE_ASSET__D2ywAvVT__ 1080w";